import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage, auth } from "../firebase";

function buildSafeFileName(fileName = "file") {
  const clean = String(fileName)
    .replace(/[^\w.\-]+/g, "_")
    .slice(0, 120);

  return clean || `file_${Date.now()}`;
}

export async function uploadSupportImage({
  file,
  ticketId = "new",
  scope = "ticket",
}) {
  if (!file) return null;

  const user = auth.currentUser;
  if (!user?.uid) {
    throw new Error("User not authenticated");
  }

  const safeName = buildSafeFileName(file.name);
  const timestamp = Date.now();

  const path = `supportTickets/${user.uid}/${ticketId}/${scope}_${timestamp}_${safeName}`;

  const storageRef = ref(storage, path);

  await uploadBytes(storageRef, file, {
    contentType: file.type || "image/jpeg",
  });

  const url = await getDownloadURL(storageRef);

  return {
    attachmentUrl: url,
    attachmentPath: path,
    attachmentName: file.name || safeName,
    attachmentSize: file.size || null,
  };
}